import { render, staticRenderFns } from "./ParcelshopMap.vue?vue&type=template&id=68991d40"
import script from "./ParcelshopMap.vue?vue&type=script&lang=js"
export * from "./ParcelshopMap.vue?vue&type=script&lang=js"
import style0 from "./ParcelshopMap.vue?vue&type=style&index=0&id=68991d40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../tracking/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports